import { render, staticRenderFns } from "./TestClosed.vue?vue&type=template&id=0ae3da8a&scoped=true&"
import script from "./TestClosed.vue?vue&type=script&lang=js&"
export * from "./TestClosed.vue?vue&type=script&lang=js&"
import style0 from "./TestClosed.vue?vue&type=style&index=0&id=0ae3da8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3da8a",
  null
  
)

export default component.exports